<template>
  <div class="row">
    <div class="col-12 d-flex align-items-center">
      <h2>{{ $t('payment_methods.payment_method', 2).capitalize() }}</h2>
      <router-link class="btn btn-primary btn-sm ms-3" :to="{name: ROUTES.PAYMENT_METHODS.CREATE}">
        <i class="fas fa-file-circle-plus"/> {{ $t('payment_methods.create') }}
      </router-link>
    </div>

    <div class="col-12">
      <DataTable stripedRows :lazy="true"
                 :paginator="true"
                 :rows="paymentMethodStore.serverOptions.rows"
                 :totalRecords="paymentMethodStore.itemLength"
                 dataKey="id"
                 :value="paymentMethodStore.payment_methods"
                 :loading="paymentMethodStore.loading"
                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                 :rowsPerPageOptions="[10,20,50]"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                 @page="onPage($event)"
                 responsiveLayout="scroll">
        <TableColumn field="id" :header="$t('payment_methods.id')"/>
        <TableColumn field="organization_id" :header="$t('payment_methods.organization_id')"/>
        <TableColumn field="name" :header="$t('payment_methods.name')"/>
        <TableColumn field="key" :header="$t('payment_methods.key')"/>
        <TableColumn field="group" :header="$t('payment_methods.group')"/>
        <TableColumn field="position" :header="$t('payment_methods.position')"/>
        <TableColumn field="updated_at" :header="$t('payment_methods.updated_at')">
          <template #body="{data}">
            {{ formatDate(data.updated_at, 'datetime') || '-' }}
          </template>
        </TableColumn>
        <TableColumn :header="$t('payment_methods.operations')">
          <template #body="{data}">
            <div class="operations-wrapper">
              <router-link class="operation-item"
                           :to="{name: ROUTES.PAYMENT_METHODS.SHOW, params: {id: data.id}}"
                           :title="$t('payment_methods.show')">
                <i class="fas fa-eye"/>
              </router-link>
              <router-link class="operation-item"
                           :to="{name: ROUTES.PAYMENT_METHODS.EDIT, params: {id: data.id}}"
                           :title="$t('payment_methods.edit')">
                <i class="fas fa-edit"/>
              </router-link>
            </div>
          </template>
        </TableColumn>
      </DataTable>
    </div>
  </div>
</template>

<script>
import {usePaymentMethodStore} from "@/stores/payment_method";
import {ROUTES} from "@/scripts/constants";

export default {
  name: 'PaymentMethodsIndex',
  setup() {
    return {
      paymentMethodStore: usePaymentMethodStore(),
    }
  },
  computed: {
    ROUTES() {
      return ROUTES
    }
  },
  created() {
    this.getPaymentMethods()
    this.setTitle(this.$t('payment_methods.payment_method', 2).capitalize())
  },
  methods: {
    getPaymentMethods() {
      this.paymentMethodStore.index()
    },
    onPage(event) {
      this.paymentMethodStore.serverOptions = event
      this.getPaymentMethods()
    }
  }
}
</script>
